import {
    FetchState,
    DynamsoftState
} from "@/shared/types";

import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: DynamsoftState = {
    fetchState: FetchState.Uninitialized,
    licenseKey: null
};

export const useDynamsoftLicenseHelperStore = defineStore("dynamsoftLicenseHelper", {
    state: (): DynamsoftState => (_.cloneDeep(initialState)),
    getters: {
        isLicenseLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setLicenseKey (licenseKey: string) {
            this.licenseKey = licenseKey;
        },
        async initLicense (): Promise<void> {
            if (this.fetchState === FetchState.Loaded) {
                return Promise.resolve();
            }
            this.setFetchState(FetchState.Loading);
            return UserService.getScannerLicense()
                .then(async response => {
                    this.setLicenseKey(response.data.licenseKey);
                    await (window as any).Dynamsoft.DCVBarcodeReader.initLicense(response.data.licenseKey);
                    this.setFetchState(FetchState.Loaded);
                    return Promise.resolve();
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: false });
                    return Promise.reject();
                });
        },
        async initLicenseV2 (): Promise<any> {
            if (this.fetchState === FetchState.Loaded) {
                return Promise.resolve({ success: true });
            }
            this.setFetchState(FetchState.Loading);
            return UserService.getScannerLicense()
                .then(async response => {
                    this.setLicenseKey(response.data.licenseKey);
                    const result = await (window as any).Capacitor.Plugins.DBR.initialize(
                        { license: response.data.licenseKey });
                    this.setFetchState(FetchState.Loaded);
                    return Promise.resolve(result);
                }).catch(err => {
                    storeHelper.handleError({ error: err, rethrow: false });
                    return Promise.reject({ success: false });
                });
        }
    }
});
